<section
  class="font-['Lato, sans-serif'] space-y-4 rounded-[14px] border border-[#e5e7eb] bg-[#fff] p-4 shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-0"
  [class.pb-24]="selectedIds().length > 0">
  <div class="flex flex-col gap-4">
    @if (view() === 'business-details') {
    <div class="flex flex-col gap-3">
      <nav class="flex min-w-0 flex-wrap items-center gap-2 text-[14px] text-[#0c66e8]">
        <button type="button" (click)="goHome()"
          class="transition hover:text-[#0052a3] hover:underline">
          Unpaid Payments Overview
        </button>
        <span class="flex items-center text-[#797f87]">
          <app-icon-v2 name="chevron-right" [size]="16" [strokeWidth]="2.5" />
        </span>
        <button type="button" (click)="onCategoryClick()"
          class="transition hover:text-[#0052a3] hover:underline">
          {{ currentCategory().label }}
        </button>
        <span class="flex items-center text-[#797f87]">
          <app-icon-v2 name="chevron-right" [size]="16" [strokeWidth]="2.5" />
        </span>
        <span class="font-medium text-[#131921] dark:text-white">{{ summaryHeading }}</span>
      </nav>

      <div class="flex flex-wrap items-start justify-between gap-3">
        <div class="min-w-0">
          <h2 class="text-[24px] font-bold leading-[1.3] text-[#141437] dark:text-white">{{ summaryHeading }}</h2>
          <p *ngIf="summarySubtitle" class="mt-0.5 text-[16px] font-normal text-[#7d7d93] dark:text-ink-muted">
            {{ summarySubtitle }}
          </p>
        </div>

        <div class="flex shrink-0 flex-wrap items-center justify-end gap-2">
          <app-unpaid-payments-is-dummy-toggle (dummyChange)="onIsDummyToggle($event)"></app-unpaid-payments-is-dummy-toggle>
          <span *ngIf="businessDetailStatusLabel"
            class="inline-flex items-center rounded-full px-2.5 py-1 text-[12px] font-semibold"
            [ngClass]="businessDetailStatusLabel === 'Active'
              ? 'bg-[#edfff3] text-[#15b268] dark:bg-[#173b31] dark:text-[#7ae5ac]'
              : 'bg-[#fff0f0] text-[#f05050] dark:bg-[#3f1d29] dark:text-[#ff9090]'">
            {{ businessDetailStatusLabel }}
          </span>
          <span *ngIf="detailSummary()?.bank_connected === 1"
            class="inline-flex items-center gap-1 rounded-full bg-[#e9f4ff] px-2.5 py-1 text-[12px] font-semibold text-[#0c66e8] dark:bg-blue-500/15 dark:text-[#9cc5ff]">
            <app-icon-v2 name="check" size="12" [strokeWidth]="3"></app-icon-v2>
            Bank Connected
          </span>
          <span *ngIf="detailSummary()?.is_vip"
            class="inline-flex items-center rounded-full bg-[#fff9e8] px-2.5 py-1 text-[12px] font-medium text-[#ffa514] dark:bg-[#4b3817] dark:text-[#ffd37a]">
            VIP
          </span>
          <button type="button"
            class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-[8px] text-[#7d7d93] transition hover:bg-[#f2f4f8] dark:text-ink-muted dark:hover:bg-surface-3"
            aria-label="More options">
            <app-icon-v2 name="ellipsis-vertical" size="18"></app-icon-v2>
          </button>
        </div>
      </div>

      <div *ngIf="detailSummary()?.contract_data"
        class="flex w-full flex-wrap items-center justify-end gap-x-4 gap-y-2">
        <ng-container *ngFor="let stat of businessDetailContractStats()">
          <span class="inline-flex items-center gap-1.5 whitespace-nowrap text-[13px] text-[#7d7d93] dark:text-ink-muted">
            <span *ngIf="stat.tone !== 'none'" class="h-2 w-2 shrink-0 rounded-full" [ngClass]="{
                'bg-[#15b268]': stat.tone === 'green',
                'bg-[#f05050]': stat.tone === 'rose',
                'bg-[#0c66e8]': stat.tone === 'blue',
                'bg-[#7d7d93]': stat.tone === 'slate'
              }"></span>
            {{ stat.label }}:
            <span class="font-semibold text-[#141437] dark:text-white">{{ stat.value }}</span>
          </span>
        </ng-container>
        <span *ngIf="detailSummary()?.contract_data?.last_contract_date"
          class="inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-[#f2f4f8] px-3 py-1.5 text-[12px] text-[#7d7d93] dark:bg-surface-3 dark:text-ink-muted">
          Last contract created:
          <span class="ml-1 font-medium text-[#38385b] dark:text-ink-soft">
            {{ $safeNavigationMigration(detailSummary()?.contract_data?.last_contract_date) | date:'MM/dd/yyyy' }}
          </span>
        </span>
      </div>
    </div>

    <div class="grid gap-4" [ngClass]="isDashboard() ? 'xl:grid-cols-3' : 'xl:grid-cols-4'">
      @if (!isDashboard()) {
        <article class="rounded-[14px] bg-[#e9f4ff] p-5 dark:bg-blue-500/15">
          <div class="flex h-full flex-col">
            <div class="flex items-center gap-3">
              <span
                class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-surface-3">
                <app-icon-v2 name="circleDollarSign" class="h-5 w-5 text-[#0c66e8] dark:text-[#9cc5ff]"
                  size="20"></app-icon-v2>
              </span>
              <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">Amount To Pay</p>
            </div>
            <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
              {{ amountToPayDisplay() | currency }}
            </div>
            <div class="mt-auto pt-6">
              <p class="text-[14px] font-medium text-[#7d7d93] dark:text-ink-muted">
                {{ totalCount() }} Payments
              </p>
            </div>
          </div>
        </article>
      }

      <article class="rounded-[14px] bg-[#edfff3] p-5 dark:bg-[#173b31]">
        <div class="flex h-full flex-col">
          <div class="flex items-center gap-3">
            <span
              class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-[#0b281f]">
              <app-icon-v2 name="calendar" class="h-5 w-5 text-[#15b268] dark:text-[#7ae5ac]" size="20"></app-icon-v2>
            </span>
            <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">Upcoming Amount</p>
          </div>
          <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
            {{ balance().upcoming_balance | currency }}
          </div>
          <div class="mt-auto pt-6">
            <p class="flex items-center gap-1.5 text-[14px] font-medium text-[#7d7d93] dark:text-ink-muted">
              Approx. In 2 Days
              <app-tooltip
                [content]="upcomingAmountTooltip"
                position="top"
                [showArrow]="true"
                [flexCenter]="true"
                [useFixedStrategy]="true"
                [delayShow]="150"
                maxWidth="300px"
                className="!z-[999]"
                triggerClassName="!cursor-help inline-flex items-center"
              >
                <button
                  type="button"
                  class="inline-flex shrink-0 items-center justify-center rounded-full text-[#7d7d93] transition hover:text-[#38385b] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-[#15b268] dark:text-ink-muted dark:hover:text-white"
                  aria-label="Upcoming amount details"
                >
                  <app-icon-v2 name="info" class="h-4 w-4" size="16"></app-icon-v2>
                </button>
              </app-tooltip>
            </p>
          </div>
        </div>
      </article>

      <article class="rounded-[14px] bg-[#fff9e8] p-5 dark:bg-[#3a2c14]"
        *ngIf="detailSummary()?.last_3_payouts?.length; else emptyLastPayoutsCard">
        <div class="flex h-full flex-col">
          <div class="flex items-center gap-3">
            <span
              class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-[#2a2010]">
              <app-icon-v2 name="calendar" class="h-5 w-5 text-[#c45d00] dark:text-[#ffd37a]" size="20"></app-icon-v2>
            </span>
            <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">Last 3 Payouts</p>
          </div>
          <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
            {{ $safeNavigationMigration(detailSummary()?.last_3_payouts_total) | currency }}
          </div>
          <div class="mt-4 space-y-1.5">
            <div *ngFor="let payout of detailSummary()?.last_3_payouts"
              class="flex items-center justify-between text-[12px] text-[#7d7d93] dark:text-ink-muted">
              <span class="font-medium text-[#38385b] dark:text-ink-soft">{{ $safeNavigationMigration(payout?.amount) | currency }}</span>
              <span>{{ $safeNavigationMigration(payout?.date) | date:'MM/dd/yyyy' }}</span>
            </div>
          </div>
        </div>
      </article>
      <ng-template #emptyLastPayoutsCard>
        <article class="rounded-[14px] bg-[#fff9e8] p-5 dark:bg-[#3a2c14]">
          <div class="flex h-full flex-col">
            <div class="flex items-center gap-3">
              <span
                class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-[#2a2010]">
                <app-icon-v2 name="calendar" class="h-5 w-5 text-[#c45d00] dark:text-[#ffd37a]" size="20"></app-icon-v2>
              </span>
              <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">Last 3 Payouts</p>
            </div>
            <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
              {{ $safeNavigationMigration(detailSummary()?.last_3_payouts_total) | currency }}
            </div>
            <p class="mt-auto pt-6 text-[14px] text-[#7d7d93] dark:text-ink-muted">No recent payouts</p>
          </div>
        </article>
      </ng-template>

      <article class="rounded-[14px] bg-[#fbf2ff] p-5 dark:bg-purple-800">
        <div class="flex h-full flex-col">
          <div class="flex items-center gap-3">
            <span
              class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-purple-500/20">
              <app-icon-v2 name="zap" class="h-5 w-5 text-[#b82dff] dark:text-[#e0baff]" size="20"></app-icon-v2>
            </span>
            <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">Urgent Payments</p>
          </div>
          <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
            {{ balance().urgent_balance | currency }}
          </div>
          <div class="mt-auto pt-6">
            <p class="text-[14px] font-medium text-[#7d7d93] dark:text-ink-muted">
              {{ balance().total_urgent_payments }} Payments
            </p>
          </div>
        </div>
      </article>
    </div>
    } @else {
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="space-y-2">
        <div class="flex flex-wrap items-center gap-2">
          <nav *ngIf="!isDashboard()" class="flex items-center gap-2 text-[15px]">
            <button type="button" (click)="goHome()"
              class="text-[#0c66e8] transition hover:text-[#0052a3] hover:underline">
              Unpaid Payments Overview
            </button>
            <ng-container>
              <span class="flex items-center text-[#797f87]">
                <app-icon-v2 name="chevron-right" [size]="16" [strokeWidth]="2.5" />
              </span>
              <span class="font-medium text-[#131921] dark:text-white">
                {{ currentCategory().label }}
              </span>
            </ng-container>
          </nav>
        </div>

        <div>
          @if (isDashboard()) {
          <h2 class="text-[24px] font-bold leading-[1.4] text-[#141437] dark:text-white">Unpaid Payments Overview</h2>
          } @else {
          <div class="relative inline-block">
            <app-dropdown [options]="categoryDropdownOptions()" [selectedValue]="filterIdDropdownSelected()"
              selectionMode="single" selectionStyle="none" [placeholder]="currentCategory().label" variant="themeBase"
              triggerClass="!p-0 !bg-transparent !border-none !shadow-none !h-auto !min-h-0 !w-auto"
              textClass="text-[24px] font-bold leading-[1.4] text-[#141437] dark:text-white"
              [chevronIcon]="'chevron-down'" iconClass="!text-[#141437] dark:!text-white ml-1" [fullWidth]="false"
              [showTooltip]="false" menuClass="!z-[200] shadow-xl !w-auto !min-w-[240px] !max-w-[240px]"
              (selectionChange)="onCategoryDropdownChange($event)"></app-dropdown>
          </div>
          }
        </div>
      </div>
      <app-unpaid-payments-is-dummy-toggle
        class="shrink-0"
        (dummyChange)="onIsDummyToggle($event)"
      ></app-unpaid-payments-is-dummy-toggle>
    </div>

    <div class="grid gap-4" [ngClass]="isDashboard() ? 'xl:grid-cols-[34fr_22fr_22fr]' : 'xl:grid-cols-[34fr_22fr_22fr_22fr]'">
      <article
        class="rounded-[14px] border border-[#e5e7eb] bg-white p-5 shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1">
        <div class="flex h-full flex-col">
          <div class="flex items-center gap-3">
            <span
              class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#f2f4f8] text-[#7d7d93] dark:bg-surface-3 dark:text-ink-soft">
              <app-icon-v2 name="wallet" class="h-5 w-5" size="20"></app-icon-v2>
            </span>
            <p class="text-[15px] font-semibold leading-[1.3] text-[#38385b] dark:text-white">
              Total Available Balance
            </p>
          </div>

          <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
            {{ balance().available_balance | currency }}
          </div>

          <div class="mt-8 space-y-3" *ngIf="balanceAllocationRows().length">
            <div class="flex flex-wrap items-end justify-between gap-3">
              <div>
                <p class="text-[13px] text-[#7d7d93] dark:text-ink-muted">Payment Allocation</p>
                <p class="mt-1 text-[16px] font-semibold leading-[1.15] text-[#141437] dark:text-white">{{
                  paymentAllocationAmount() | currency:'USD':'symbol':'1.0-0' }}</p>
              </div>
              <button type="button"
                class="inline-flex h-[36px] items-center justify-center rounded-[8px] bg-[#f2f4f8] px-3.5 text-[14px] font-semibold text-[#5a5a7b] transition hover:bg-[#e9edf3] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-white/10">
                Edit Allocation
              </button>
            </div>

            <app-data-progress-bar [data]="balanceAllocationProgressData()" [showItemHeader]="false"
              [heightClass]="'!h-2.5'"></app-data-progress-bar>

            <div class="flex flex-wrap items-center gap-x-3 gap-y-2 text-[13px]">
              <ng-container *ngFor="let row of allocationVisibleRows()">
                <span class="inline-flex items-center gap-1.5 text-[#7d7d93] dark:text-ink-soft">
                  <span class="h-2.5 w-2.5 rounded-full" [style.backgroundColor]="row.color"></span>
                  {{ row.label }}
                  <span class="font-medium text-[#141437] dark:text-white">{{ row.amount | currency }}</span>
                </span>
              </ng-container>
              <span *ngIf="allocationMoreCount() > 0"
                class="inline-flex items-center rounded-full bg-[#f2f4f8] px-2 py-0.5 text-[12px] font-medium text-[#7d7d93] dark:bg-surface-3 dark:text-ink-muted">
                +{{ allocationMoreCount() }} more
              </span>
            </div>
          </div>
        </div>
      </article>

      <article class="rounded-[14px] bg-[#edfff3] p-5 dark:bg-[#173b31]">
        <div class="flex h-full flex-col">
          <div class="flex items-center gap-3">
            <span
              class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-[#0b281f]">
              <app-icon-v2 name="calendar" class="h-5 w-5 text-[#15b268] dark:text-[#7ae5ac]" size="20"></app-icon-v2>
            </span>
            <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">
              Upcoming Amount
            </p>
          </div>

          <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
            {{ balance().upcoming_balance | currency }}
          </div>

          <div class="mt-auto pt-8">
            <div class="border-t border-[#dcebdd] dark:border-[#1f4a3f]"></div>
            <p class="mt-3.5 flex items-center gap-1.5 text-[14px] font-medium text-[#7d7d93] dark:text-ink-muted">
              Approx. In 2 Days
              <app-tooltip
                [content]="upcomingAmountTooltip"
                position="top"
                [showArrow]="true"
                [flexCenter]="true"
                [useFixedStrategy]="true"
                [delayShow]="150"
                maxWidth="300px"
                className="!z-[999]"
                triggerClassName="!cursor-help inline-flex items-center"
              >
                <button
                  type="button"
                  class="inline-flex shrink-0 items-center justify-center rounded-full text-[#7d7d93] transition hover:text-[#38385b] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-[#15b268] dark:text-ink-muted dark:hover:text-white"
                  aria-label="Upcoming amount details"
                >
                  <app-icon-v2 name="info" class="h-4 w-4" size="16"></app-icon-v2>
                </button>
              </app-tooltip>
            </p>
          </div>
        </div>
      </article>

      @if (!isDashboard()) {
        <article class="rounded-[14px] bg-[#e9f4ff] p-5 dark:bg-blue-500/15">
          <div class="flex h-full flex-col">
            <div class="flex items-center gap-3">
              <span
                class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-surface-3">
                <app-icon-v2 name="circleDollarSign" class="h-5 w-5 text-[#0c66e8] dark:text-[#9cc5ff]"
                  size="20"></app-icon-v2>
              </span>
              <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">
                Amount To Pay
              </p>
            </div>

            <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
              {{ amountToPayDisplay() | currency }}
            </div>

            <div class="mt-auto pt-8">
              <div class="border-t border-[#d8e8f8] dark:border-line"></div>
              <p class="mt-3.5 flex items-center gap-1.5 text-[14px] font-medium text-[#7d7d93] dark:text-ink-muted">
                {{ totalCount() }} Payments
              </p>
            </div>
          </div>
        </article>
      }

      <article class="rounded-[14px] bg-[#fbf2ff] p-5 dark:bg-purple-800">
        <div class="flex h-full flex-col">
          <div class="flex items-center gap-3">
            <span
              class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm dark:bg-purple-500/20">
              <app-icon-v2 name="zap" class="h-5 w-5 text-[#b82dff] dark:text-[#e0baff]" size="20"></app-icon-v2>
            </span>
            <p class="text-[15px] font-semibold text-[#38385b] dark:text-white">
              Urgent Payments
            </p>
          </div>

          <div class="mt-4 text-[32px] font-bold leading-[1.2] tracking-[-0.02em] text-[#141437] dark:text-white">
            {{ balance().urgent_balance | currency }}
          </div>
          <div class="mt-1.5 text-[15px] font-medium text-[#7d7d93] dark:text-ink-muted">
            {{ balance().total_urgent_payments }} Payments
          </div>

          <div class="mt-auto pt-6">
            <button type="button"
              class="inline-flex h-[42px] w-full items-center justify-center rounded-[8px] bg-[#b82dff] px-4 text-[14px] font-semibold text-white transition hover:bg-[#a120da] disabled:cursor-not-allowed disabled:opacity-60"
              [disabled]="submitting() || balance().total_urgent_payments === 0" (click)="payUrgentPayments()">
              Pay Urgent
            </button>
          </div>
        </div>
      </article>
    </div>
    }
  </div>



  <!-- <div *ngIf="failureRows().length"
    class="rounded-[14px] border border-[#ffd79b] bg-[#fff9e8] px-4 py-3 text-[14px] text-[#c45d00] dark:border-[#5a431c] dark:bg-[#3a2c14] dark:text-[#ffd37a]">
    <div class="font-semibold">Some payment rows failed to transfer.</div>
    <ul class="mt-2 list-disc pl-5">
      <li *ngFor="let failure of failureRows() | slice:0:5">
        {{ failure?.error || failure?.message || failure | json }}
      </li>
    </ul>
  </div> -->

  <div *ngIf="isDashboard(); else listingShell"
    class="relative min-h-[400px] overflow-hidden rounded-[14px] border border-[#e5e7eb] bg-white shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1">
    <div *ngIf="dashboardLoading()"
      class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 backdrop-blur-sm dark:bg-surface-1/60">
      <div class="flex flex-col items-center gap-4">
        <div class="h-10 w-10 animate-spin rounded-full border-4 border-purple-600 border-t-transparent"></div>
        <p class="animate-pulse font-bold text-slate-600 dark:text-slate-400">Loading unpaid dashboard...</p>
      </div>
    </div>

    <div class="space-y-4 p-4" [ngClass]="{ 'pointer-events-none opacity-50': dashboardLoading() }">
      <div *ngIf="!dashboardLoading() && !dashboardSections().length"
        class="rounded-[14px] border border-[#ffd79b] bg-[#fff9e8] px-4 py-3 text-[14px] text-[#c45d00] dark:border-[#5a431c] dark:bg-[#3a2c14] dark:text-[#ffd37a]">
        No unpaid dashboard categories are available for the selected version window.
      </div>

      <div *ngIf="dashboardSections().length" class="space-y-8">
        <div *ngFor="let section of dashboardTableSections()" class="space-y-4">
          <h3 class="text-[18px] font-semibold text-[#141437] dark:text-white">{{ section.title }}</h3>

          <app-scroll-table [showHeading]="false" [showTableWithBorderAndRadius]="true" [showHeaderIcon]="false"
            tableClass="table-fixed min-w-full" [tableData]="section.tableRows" [headers]="section.headers"
            [tableKey]="'denefits-dashboard-' + section.key" (fetchData)="onDashboardTableAction($event)"></app-scroll-table>
        </div>
      </div>
    </div>
  </div>

  <ng-template #listingShell>
    <div class="space-y-4">
      <section *ngIf="view() !== 'business-details'"
        class="relative z-10 rounded-[14px] border border-[#e5e7eb] bg-white p-4 shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1">
        @if (isLendeeFilter()) {
        <div class="flex flex-nowrap items-end gap-2 pb-0.5">
          <div class="w-[10rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Share Type</label>
            <div class="relative z-[30]">
              <app-dropdown
                [options]="lendeeShareTypeOptions"
                [selectedValue]="'' + lendeeShareType()"
                selectionMode="single"
                placeholder="Share Type"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl"
                (selectionChange)="onLendeeShareTypeChange($event)"
              ></app-dropdown>
            </div>
          </div>

          <div class="w-[10rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Payment Status</label>
            <div class="relative z-[29]">
              <app-dropdown
                [options]="lendeePaymentStatusOptions"
                [selectedValue]="'' + lendeePaymentStatus()"
                selectionMode="single"
                placeholder="Payment Status"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl"
                (selectionChange)="onLendeePaymentStatusChange($event)"
              ></app-dropdown>
            </div>
          </div>

          <div class="min-w-[10.5rem] max-w-[14rem] shrink-0 flex-[1_1_10.5rem]">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Search</label>
            <div class="flex h-[38px] overflow-hidden rounded-[10px] border border-[#d1d5dc] bg-white dark:border-surface-3 dark:bg-surface-0">
              <div class="relative min-w-0 flex-1">
                <input
                  class="h-full w-full border-0 bg-transparent pl-9 pr-2 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:ring-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
                  [ngModel]="search()"
                  (ngModelChange)="search.set($event)"
                  (keyup.enter)="applyFilters()"
                  placeholder="Search records..."
                />
                <app-icon-v2
                  name="search"
                  size="16"
                  class="pointer-events-none absolute inset-y-0 left-2.5 my-auto text-[#7d7d93] dark:text-ink-muted"
                ></app-icon-v2>
              </div>
            </div>
          </div>

          <div class="ml-auto flex shrink-0 items-end gap-2 self-end">
            <app-button variant="primary" size="md" [maxHeight]="'38px'" (click)="applyFilters()">Apply</app-button>
            <button
              type="button"
              class="inline-flex h-[38px] items-center gap-1.5 rounded-[10px] border border-[#d1d5dc] bg-white px-4 text-[14px] font-semibold text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:hover:bg-surface-3"
              (click)="resetFilters()"
            >
              Reset
            </button>
          </div>
        </div>
        } @else {
        <div class="space-y-3">
          <div class="flex min-w-0 flex-nowrap items-center gap-2 overflow-x-auto-">
            <div class="relative z-[30] w-[200px] shrink-0" *ngIf="view() !== 'business-details'">
              <app-dropdown [options]="viewDropdownOptions()" [selectedValue]="view()" selectionMode="single"
                placeholder="All Payments" variant="themeBase" customHeight="'38px'" size="sm" [rounded]="'md'"
                [fullWidth]="true" [showTooltip]="false" iconName="calendar" iconClass="!text-[#ad46ff]"
                chevronIcon="chevron-down" [tooltipFixedStrategy]="true" menuClass="!z-[200] shadow-xl"
                (selectionChange)="onListingViewDropdownChange($event)"></app-dropdown>
            </div>

            <button type="button"
              class="inline-flex h-[38px] shrink-0 items-center rounded-[8px] px-3 text-[14px] font-medium transition"
              [ngClass]="getQuickToggleClass(statusFilter() === '1', 'green')" (click)="setQuickStatus('1')">
              Active
            </button>
            <button type="button"
              class="inline-flex h-[38px] shrink-0 items-center rounded-[8px] px-3 text-[14px] font-medium transition"
              [ngClass]="getQuickToggleClass(statusFilter() === '2', 'rose')" (click)="setQuickStatus('2')">
              Inactive
            </button>
            <button type="button"
              class="inline-flex h-[38px] shrink-0 items-center rounded-[8px] px-3 text-[14px] font-medium transition"
              [ngClass]="getQuickToggleClass(urgentOnly(), 'violet')" (click)="toggleQuickUrgent()">
              Urgent
            </button>
            <button type="button"
              class="inline-flex h-[38px] shrink-0 items-center rounded-[8px] px-3 text-[14px] font-medium transition"
              [ngClass]="getQuickToggleClass(vipOnly(), 'violet')" (click)="toggleQuickVip()">
              VIP
            </button>

            <div class="relative z-[29] flex shrink-0 items-center gap-2">
              <div class="w-[9.5rem] shrink-0">
                <app-selection
                  mode="date-picker"
                  [enableYearMonthPicker]="true"
                  [disableFutureDates]="true"
                  [minDate]="versionDateRange().startDate"
                  [ngModel]="startDate()"
                  (ngModelChange)="onStartDateChange($event)"
                  [maxDate]="startDateMax()"
                  datePlaceholder="Start date"
                ></app-selection>
              </div>
              <div class="w-[9.5rem] shrink-0">
                <app-selection
                  mode="date-picker"
                  [enableYearMonthPicker]="true"
                  [disableFutureDates]="true"
                  [minDate]="startDate()"
                  [ngModel]="endDate()"
                  (ngModelChange)="onEndDateChange($event)"
                  [maxDate]="versionDateRange().endDate"
                  datePlaceholder="End date"
                ></app-selection>
              </div>
            </div>

            <div class="flex flex-wrap items-end gap-2">
            </div>

            <button type="button"
              class="inline-flex h-[38px] shrink-0 items-center gap-1.5 rounded-[8px] px-3 text-[14px] font-medium transition"
              [ngClass]="getQuickToggleClass(false)" (click)="resetFilters()">
              <app-icon-v2 name="rotate-ccw" size="16" class="text-[#7d7d93] dark:text-ink-muted"></app-icon-v2>
              Reset
            </button>

            <div class="min-w-4 flex-1" aria-hidden="true"></div>

            <div class="relative w-[min(100%,280px)] shrink-0">
              <input
                class="h-[38px] w-full rounded-[10px] border border-[#d1d5dc] bg-white pl-10 pr-4 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:border-[#0c66e8] dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
                [ngModel]="search()" (ngModelChange)="search.set($event)" (keyup.enter)="applyFilters()"
                placeholder="Search records..." />
              <app-icon-v2 name="search" size="16"
                class="pointer-events-none absolute inset-y-0 left-3 my-auto text-[#7d7d93] dark:text-ink-muted"></app-icon-v2>
            </div>
            <app-button variant="primary" size="md" [maxHeight]="'38px'" (click)="applyFilters()">
              Apply
            </app-button>

            <div class="relative z-[30] shrink-0">
              <app-dropdown [options]="exportDropdownOptions" selectionMode="single" selectionStyle="none"
                variant="themeBase" [fullWidth]="false" className="!w-auto" [showTooltip]="false"
                [tooltipFixedStrategy]="true" menuClass="!z-[200] min-w-[160px] shadow-xl"
                (selectionChange)="onExportDropdownChange($event)">
                <span appDropdownTrigger tabindex="0" role="button"
                  class="inline-flex h-[38px] cursor-pointer items-center gap-2 rounded-[8px] bg-[#f2f5f8] px-4 text-[13px] font-bold uppercase tracking-[0.04em] text-[#38385b] transition hover:bg-[#e8ecf1] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
                  [class.pointer-events-none]="exporting()" [class.opacity-60]="exporting()">
                  <app-icon-v2 name="external-link" size="16" class="text-[#38385b] dark:text-ink-soft"></app-icon-v2>
                  {{ exporting() ? 'Exporting...' : 'EXPORT' }}
                </span>
              </app-dropdown>
            </div>
          </div>
        </div>
        }
      </section>

      <div
        class="relative z-0 min-h-[400px] overflow-visible rounded-[14px] border border-[#e5e7eb] bg-white shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1">
        <div *ngIf="tableBusy()"
          class="absolute inset-0 z-10 flex items-center justify-center overflow-hidden rounded-[14px] bg-white/60 backdrop-blur-sm dark:bg-surface-1/60">
          <div class="flex flex-col items-center gap-4">
            <div class="h-10 w-10 animate-spin rounded-full border-4 border-purple-600 border-t-transparent"></div>
            <p class="animate-pulse font-bold text-slate-600 dark:text-slate-400">{{ tableBusyMessage() }}</p>
          </div>
        </div>

        <div *ngIf="view() === 'business-details'"
          class="flex flex-nowrap items-center justify-between gap-4 px-4 pt-4"
          [ngClass]="{ 'pointer-events-none opacity-50': tableBusy() }">
          <div class="flex shrink-0 items-center gap-6">
            <button type="button"
              class="inline-flex items-center gap-2 border-b-2 pb-3 pt-1 text-[14px] font-semibold transition outline-none"
              [ngClass]="detailMode() === 'all'
                ? 'border-[#7c3aed] text-[#141437] dark:border-purple-400 dark:text-white'
                : 'border-transparent text-[#7d7d93] hover:text-[#38385b] dark:text-ink-muted dark:hover:text-ink-soft'"
              (click)="setDetailMode('all')">
              <app-icon-v2 name="list" size="16"></app-icon-v2>
              All Payments
            </button>
            <button *ngIf="canUseContractMode" type="button"
              class="inline-flex items-center gap-2 border-b-2 pb-3 pt-1 text-[14px] font-semibold transition outline-none"
              [ngClass]="detailMode() === 'contract'
                ? 'border-[#7c3aed] text-[#141437] dark:border-purple-400 dark:text-white'
                : 'border-transparent text-[#7d7d93] hover:text-[#38385b] dark:text-ink-muted dark:hover:text-ink-soft'"
              (click)="setDetailMode('contract')">
              <app-icon-v2 name="layers" size="16"></app-icon-v2>
              {{ contractTabLabel }}
            </button>
          </div>

          <div class="flex shrink-0 flex-nowrap items-center gap-3">
            <div class="relative w-[280px] shrink-0">
              <input
                class="h-[38px] w-full rounded-[10px] border border-[#d1d5dc] bg-white pl-10 pr-4 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:border-[#0c66e8] dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
                [ngModel]="search()" (ngModelChange)="search.set($event)" (keyup.enter)="applyFilters()"
                placeholder="Search records..." />
              <app-icon-v2 name="search" size="16"
                class="pointer-events-none absolute inset-y-0 left-3 my-auto text-[#7d7d93] dark:text-ink-muted"></app-icon-v2>
            </div>
            <app-toggle [checked]="urgentOnly()" label="Urgent Payments Only" labelPosition="after" size="md"
              className="shrink-0 whitespace-nowrap" (toggleChange)="setUrgentOnly($event)"></app-toggle>
          </div>
        </div>

        <div [ngClass]="view() === 'business-details' ? 'px-4 pb-4 pt-3' : 'p-4'"
          [class.pointer-events-none]="tableBusy()" [class.opacity-50]="tableBusy()">
      <div *ngIf="!tableBusy() && !rows().length"
        class="flex min-h-[280px] flex-col items-center justify-center px-4 py-12 text-center">
        <svg width="138" height="81" viewBox="0 0 138 81" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M129.789 70.1323H2.66082C1.95537 70.1315 1.27904 69.8553 0.780215 69.3643C0.281386 68.8733 0.000794248 68.2076 0 67.5132V2.61905C0.000819236 1.92468 0.281418 1.25899 0.780242 0.767996C1.27907 0.277004 1.95538 0.000806374 2.66082 0H129.789C130.494 0.000782547 131.171 0.276972 131.67 0.76797C132.168 1.25897 132.449 1.92467 132.45 2.61905V67.5132C132.449 68.2076 132.168 68.8733 131.67 69.3643C131.171 69.8553 130.494 70.1315 129.789 70.1323ZM2.66082 0.582011C2.11214 0.582616 1.5861 0.797426 1.19812 1.17931C0.810146 1.5612 0.591909 2.07898 0.591294 2.61905V67.5132C0.591934 68.0533 0.810183 68.5711 1.19816 68.9529C1.58613 69.3348 2.11215 69.5496 2.66082 69.5503H129.789C130.338 69.5496 130.864 69.3348 131.252 68.9529C131.64 68.571 131.858 68.0533 131.859 67.5132V2.61905C131.858 2.07899 131.64 1.56123 131.252 1.17934C130.864 0.797463 130.338 0.582641 129.789 0.582011H2.66082Z"
            fill="#EAEAEA" />
          <path
            d="M31.4884 31H12.5116C11.8457 30.9992 11.2073 30.717 10.7365 30.2154C10.2656 29.7138 10.0008 29.0337 10 28.3243V11.6757C10.0008 10.9663 10.2656 10.2862 10.7365 9.7846C11.2073 9.28299 11.8457 9.00082 12.5116 9H31.4884C32.1543 9.0008 32.7927 9.28296 33.2635 9.78457C33.7344 10.2862 33.9993 10.9663 34 11.6757V28.3243C33.9993 29.0337 33.7344 29.7138 33.2635 30.2154C32.7927 30.717 32.1543 30.9992 31.4884 31ZM12.5116 9.59459C11.9937 9.59521 11.4972 9.81467 11.1309 10.2048C10.7647 10.595 10.5587 11.1239 10.5581 11.6757V28.3243C10.5587 28.8761 10.7647 29.405 11.1309 29.7952C11.4972 30.1853 11.9937 30.4048 12.5116 30.4054H31.4884C32.0063 30.4048 32.5028 30.1853 32.869 29.7952C33.2353 29.405 33.4413 28.8761 33.4419 28.3243V11.6757C33.4413 11.1239 33.2353 10.595 32.869 10.2048C32.5028 9.81471 32.0063 9.59524 31.4884 9.59459H12.5116Z"
            fill="#EAEAEA" />
          <path
            d="M12.0906 37C11.5362 37 11.0044 37.158 10.6123 37.4393C10.2203 37.7206 10 38.1022 10 38.5C10 38.8978 10.2203 39.2794 10.6123 39.5607C11.0044 39.842 11.5362 40 12.0906 40H117.909C118.464 40 118.996 39.842 119.388 39.5607C119.78 39.2794 120 38.8978 120 38.5C120 38.1022 119.78 37.7206 119.388 37.4393C118.996 37.158 118.464 37 117.909 37H12.0906Z"
            fill="#F5F5F5" />
          <path
            d="M43.224 14C42.8994 14 42.5881 14.2107 42.3585 14.5858C42.129 14.9609 42 15.4696 42 16C42 16.5304 42.129 17.0391 42.3585 17.4142C42.5881 17.7893 42.8994 18 43.224 18H69.776C70.1006 18 70.4119 17.7893 70.6415 17.4142C70.871 17.0391 71 16.5304 71 16C71 15.4696 70.871 14.9609 70.6415 14.5858C70.4119 14.2107 70.1006 14 69.776 14H43.224Z"
            fill="#EAEAEA" />
          <path
            d="M43.4825 22C43.0893 22 42.7122 22.2107 42.4342 22.5858C42.1562 22.9609 42 23.4696 42 24C42 24.5304 42.1562 25.0391 42.4342 25.4142C42.7122 25.7893 43.0893 26 43.4825 26H92.5175C92.9107 26 93.2878 25.7893 93.5658 25.4142C93.8438 25.0391 94 24.5304 94 24C94 23.4696 93.8438 22.9609 93.5658 22.5858C93.2878 22.2107 92.9107 22 92.5175 22H43.4825Z"
            fill="#EAEAEA" />
          <path
            d="M11.6155 43C11.187 43 10.7761 43.158 10.4732 43.4393C10.1702 43.7206 10 44.1022 10 44.5C10 44.8978 10.1702 45.2794 10.4732 45.5607C10.7761 45.842 11.187 46 11.6155 46H93.3845C93.813 46 94.2239 45.842 94.5268 45.5607C94.8298 45.2794 95 44.8978 95 44.5C95 44.1022 94.8298 43.7206 94.5268 43.4393C94.2239 43.158 93.813 43 93.3845 43H11.6155Z"
            fill="#F5F5F5" />
          <path
            d="M11.2354 49C10.9077 49 10.5935 49.158 10.3618 49.4393C10.1302 49.7206 10 50.1022 10 50.5C10 50.8978 10.1302 51.2794 10.3618 51.5607C10.5935 51.842 10.9077 52 11.2354 52H73.7646C74.0923 52 74.4065 51.842 74.6382 51.5607C74.8698 51.2794 75 50.8978 75 50.5C75 50.1022 74.8698 49.7206 74.6382 49.4393C74.4065 49.158 74.0923 49 73.7646 49H11.2354Z"
            fill="#F5F5F5" />
          <path
            d="M10.8553 55C10.6284 55 10.4109 55.158 10.2505 55.4393C10.0901 55.7206 10 56.1022 10 56.5C10 56.8978 10.0901 57.2794 10.2505 57.5607C10.4109 57.842 10.6284 58 10.8553 58H54.1447C54.3716 58 54.5891 57.842 54.7495 57.5607C54.9099 57.2794 55 56.8978 55 56.5C55 56.1022 54.9099 55.7206 54.7495 55.4393C54.5891 55.158 54.3716 55 54.1447 55H10.8553Z"
            fill="#F5F5F5" />
          <path
            d="M22 25C24.7614 25 27 22.7614 27 20C27 17.2386 24.7614 15 22 15C19.2386 15 17 17.2386 17 20C17 22.7614 19.2386 25 22 25Z"
            fill="#EAEAEA" />
          <path
            d="M110.3 43.9258C116.673 42.7288 122.804 46.9346 123.997 53.3135C124.591 56.491 123.844 59.6074 122.161 62.084L136.68 75.9404C137.724 76.9357 137.777 78.5832 136.802 79.6445C135.757 80.7811 133.97 80.7843 132.922 79.6533H132.921L119.35 64.9941C117.987 65.9865 116.388 66.6992 114.623 67.0303C108.249 68.2274 102.118 64.0217 100.926 57.6426C99.731 51.2611 103.927 45.1229 110.3 43.9258ZM120.618 53.9512C119.775 49.4382 115.439 46.4668 110.935 47.3105C106.43 48.1545 103.462 52.497 104.305 57.0107C105.148 61.5236 109.483 64.4942 113.988 63.6504C118.493 62.8065 121.461 58.4648 120.618 53.9512Z"
            fill="#AD46FF" stroke="white" />
        </svg>
        <h3 class="mb-2 text-[22px] font-bold text-[#141437] dark:text-white">No Data Found</h3>
        <p class="text-[16px] text-[#7d7d93] dark:text-ink-muted">
          No matching records found. Please change your search
        </p>
      </div>

      <app-paginated-table id="denefits-listing-table" class="denefits-listing-table" *ngIf="rows().length && view() === 'listing' && !isLendeeFilter()" [headers]="listingHeaders()"
        [tableData]="rows()" [isCheckboxShow]="true" [selection]="selectedRows()" [isRowSelectable]="canSelectRowBind"
        (selectionChange)="onSelectionChange($event)" [serverSide]="true" [totalItems]="totalCount()"
        [pageCount]="totalPages()" [currentPage]="page()" [pageSize]="pageSize" (pageChange)="goToPage($event)"
        [tableWrapperClass]="'h-full !overflow-visible rounded-2xl dark:bg-surface-1 bg-white'"
        containerClass="!overflow-visible"
        [cellTemplates]="{
          contractId: contractIdTemplate,
          businessName: businessNameTemplate,
          recurringAmount: recurringAmountTemplate,
          status: statusTemplate,
          pfStatus: pfStatusTemplate,
          paymentDate: paymentDateTemplate,
          receivedOn: receivedOnTemplate,
          lastContractDate: lastContractDateTemplate,
          amountToPay: amountToPayTemplate,
          achArPpType: achArPpTypeTemplate,
          rewardType: rewardTypeTemplate,
          transferToBusiness: transferToBusinessTemplate,
          orp: orpTemplate,
          instantClaim: instantClaimTemplate,
          action: actionTemplate
        }">
      </app-paginated-table>

      @if (isLendeeFilter() && rows().length) {
      <div class="min-w-0 overflow-x-auto">
        <app-paginated-table id="denefits-lendee-table" class="denefits-lendee-table"
          [headers]="lendeeTableHeaders"
          [tableData]="rows()"
          [isCheckboxShow]="false"
          [selection]="selectedRows()"
          [isRowSelectable]="canSelectRowBind"
          (selectionChange)="onSelectionChange($event)"
          [serverSide]="true"
          [totalItems]="totalCount()"
          [pageCount]="totalPages()"
          [currentPage]="page()"
          [pageSize]="pageSize"
          (pageChange)="goToPage($event)"
          [tableKey]="'denefits-lendee'"
          tableClass="min-w-full"
          [tableWrapperClass]="'h-full rounded-2xl dark:bg-surface-1 bg-white'"
          containerClass="overflow-x-auto min-w-0"
          [cellTemplates]="{
            serialNo: lendeeSerialNoTemplate,
            payableAmount: lendeePayableAmountTemplate,
            shareType: lendeeShareTypeTemplate,
            lendeeStatus: lendeeStatusTemplate,
            contractDetails: lendeeContractDetailsTemplate,
            businessDetails: lendeeBusinessDetailsTemplate,
            paymentDetails: lendeePaymentDetailsTemplate,
            action: lendeeActionTemplate
          }"
        ></app-paginated-table>
      </div>
      }

      <app-paginated-table id="denefits-business-table" class="denefits-business-table" *ngIf="rows().length && view() === 'business'" [headers]="businessHeaders()"
        [tableData]="rows()" [isCheckboxShow]="true" [selection]="selectedRows()" [isRowSelectable]="canSelectRowBind"
        (selectionChange)="onSelectionChange($event)" [serverSide]="true" [totalItems]="totalCount()"
        [pageCount]="totalPages()" [currentPage]="page()" [pageSize]="pageSize" (pageChange)="goToPage($event)" tableClass="table-fixed"
        [cellTemplates]="{
          businessName: businessNameTemplate,
          status: businessStatusTemplate,
          urgentPayments: businessUrgentPaymentsTemplate,
          amountToPay: businessAmountTemplate,
          action: businessActionTemplate
        }">
      </app-paginated-table>

      <app-paginated-table id="denefits-business-details-all-table" class="denefits-business-details-all-table"
        *ngIf="rows().length && view() === 'business-details' && detailMode() === 'all'"
        [headers]="detailsAllHeaders()" [tableData]="rows()" [isCheckboxShow]="true" [selection]="selectedRows()"
        [isRowSelectable]="canSelectRowBind" (selectionChange)="onSelectionChange($event)" [serverSide]="true"
        [totalItems]="totalCount()" [pageCount]="totalPages()" [currentPage]="page()" [pageSize]="pageSize" (pageChange)="goToPage($event)"
        [tableWrapperClass]="'h-full !overflow-visible !rounded-none !border-0 !shadow-none dark:bg-surface-1 bg-white'"
        containerClass="!overflow-visible"
        [cellTemplates]="{
          contractId: contractIdTemplate,
          recurringAmount: recurringAmountTemplate,
          paidAmount: recurringAmountTemplate,
          status: statusTemplate,
          pfStatus: pfStatusTemplate,
          achArPpType: achArPpTypeTemplate,
          rewardType: rewardTypeTemplate,
          paymentDate: paymentDateTemplate,
          receivedOn: receivedOnTemplate,
          amountToPay: amountToPayTemplate,
          action: actionTemplate
        }">
      </app-paginated-table>

      <section *ngIf="rows().length && view() === 'business-details' && detailMode() === 'contract'"
        class="space-y-10">
        <article *ngFor="let group of groupedDetailRows()" class="space-y-3">
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex items-center gap-2">
              <p class="text-[14px] text-[#7d7d93] dark:text-ink-muted">
                <span class="font-medium">{{ isContractWiseMode() ? 'ID:' : 'Contract ID:' }}</span>
                <span class="ml-1 font-semibold text-[#0c66e8] dark:text-[#6eb3ff]">{{ group.contractCode }}</span>
              </p>
              @if (group.paymentTypeLabel) {
                <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-[12px] font-semibold" [ngClass]="group.paymentTypeClass">
                  {{ group.paymentTypeLabel }}
                </span>
              }
            </div>
            <p class="text-[14px] text-[#7d7d93] dark:text-ink-muted">
              <span class="font-medium">Total Amount:</span>
              <span class="ml-1 font-semibold text-[#141437] dark:text-white">{{ group.totalAmount | currency }}</span>
            </p>
          </div>

          <div class="overflow-auto">
            <app-paginated-table [id]="'denefits-contract-details-table-' + group.key" class="denefits-contract-details-table" [headers]="detailsContractHeaders" [tableData]="group.rows" [isCheckboxShow]="true"
              [selection]="selectedRows()" [isRowSelectable]="canSelectRowBind"
              (selectionChange)="onSelectionChange($event)" [hidePagination]="true"
              [tableKey]="'denefits-contract-' + group.key"
              [tableWrapperClass]="'h-full !overflow-visible !rounded-none !border-0 !shadow-none dark:bg-surface-1 bg-white'"
              containerClass="!overflow-visible !border-0 !rounded-none"
              [cellTemplates]="{
                recurringAmount: recurringAmountTemplate,
                paymentDate: paymentDateTemplate,
                receivedOn: receivedOnTemplate,
                amountToPay: amountToPayTemplate,
                action: contractActionTemplate
              }">
            </app-paginated-table>
          </div>
        </article>
      </section>

      <div *ngIf="rows().length && view() === 'business-details' && detailMode() === 'contract'"
        class="flex justify-end px-4 pb-4 pt-2 text-[14px] text-[#7d7d93] dark:text-ink-muted">
        <app-pagination [currentPage]="page()" [totalItems]="totalCount()" [pageSize]="pageSize"
          [pageCount]="totalPages()" [currentPageItemCount]="rows().length" [pageSizes]="[pageSize]"
          (pageChange)="goToPage($event)"></app-pagination>
      </div>
        </div>
      </div>

      <!-- Cell Templates -->
      <ng-template #contractIdTemplate let-row>
        <div class="flex flex-col items-start gap-1">
          <span class="text-[14px] font-medium text-[#141437] dark:text-white">
            {{ getAccountCode(row) }}
          </span>
          @if (showsContractStatusPill() && getContractStatusLabel(row)) {
            <span
              class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold"
              [ngClass]="getContractStatusPillClass(row)"
            >
              {{ getContractStatusLabel(row) }}
            </span>
          }
        </div>
      </ng-template>

      <ng-template #businessNameTemplate let-row>
        <div class="space-y-1">
          <div class="flex flex-wrap items-center gap-2">
            <span class="text-[14px] font-semibold text-[#141437] dark:text-white">
              {{ getPrimaryName(row) }}
            </span>
            <span *ngIf="isBusinessVip(row)"
              class="inline-flex items-center gap-1 rounded-full bg-[#fff9e8] px-2 py-0.5 text-[11px] font-semibold text-[#ffa514] dark:bg-[#4b3817] dark:text-[#ffd37a]">
              <app-icon-v2 name="gem" size="10" customClass="text-[#ffa514]"></app-icon-v2>
              VIP
            </span>
          </div>
          <div class="text-[12px] text-[#7d7d93] dark:text-ink-muted">
            {{ getSecondaryName(row) }}
          </div>
        </div>
      </ng-template>

      <ng-template #businessStatusTemplate let-row>
        <div class="flex flex-col items-start gap-1">
          <div class="block w-full text-[14px] font-medium leading-tight" [ngClass]="{
            'text-[#15b268]': getStatusTone(getStatusLabel(row)) === 'success',
            'text-[#f05050]': getStatusTone(getStatusLabel(row)) === 'danger',
            'text-[#ffa514]': getStatusTone(getStatusLabel(row)) === 'warning',
            'text-[#7d7d93] dark:text-ink-muted': getStatusTone(getStatusLabel(row)) === 'neutral'
          }">
            {{ getStatusLabel(row) }}
          </div>

          @if (filterId() === 3) {
          <div
            class="inline-flex w-fit items-center rounded-full bg-[#f2f5f8] px-2 py-0.5 text-[12px] text-[#7d7d93] dark:bg-surface-3 dark:text-ink-muted">
            Total Payments:
            <span class="ml-0.5 font-semibold text-[#141437] dark:text-white">{{ getTotalContracts(row) }}</span>
          </div>
          } @else if (hasContractBreakdown(row)) {
          <div
            class="inline-flex w-fit cursor-default items-center rounded-lg bg-[#f2f2f2] px-2 py-0.5 text-[12px] text-[#7d7d93] transition hover:bg-[#e9edf3] dark:bg-surface-3 dark:text-ink-muted dark:hover:bg-white/10"
            data-contract-popover-root
            [class.ring-1]="isContractPopoverOpen(row)"
            [class.ring-[#e5e7eb]]="isContractPopoverOpen(row)"
            (mouseenter)="openContractPopover(row, $event)"
            (mouseleave)="scheduleCloseContractPopover()">
            Contracts:
            <span class="ml-0.5 font-semibold text-[#141437] dark:text-white">{{ getTotalContracts(row) }}</span>
          </div>
          } @else {
          <div
            class="inline-flex w-fit items-center rounded-full bg-[#f2f5f8] px-2 py-0.5 text-[12px] text-[#7d7d93] dark:bg-surface-3 dark:text-ink-muted">
            Contracts:
            <span class="ml-0.5 font-semibold text-[#141437] dark:text-white">{{ getTotalContracts(row) }}</span>
          </div>
          }
        </div>
      </ng-template>

      <ng-template #businessUrgentPaymentsTemplate let-row>
        @if (getUrgentPaymentAmount(row) > 0 || getUrgentCount(row) > 0) {
        <div class="flex flex-col gap-1">
          @if (getUrgentPaymentAmount(row) > 0) {
          <span class="text-[14px] font-semibold text-[#141437] dark:text-white">
            {{ getUrgentPaymentAmount(row) | currency }}
          </span>
          }
          @if (getUrgentCount(row) > 0) {
          <span
            class="inline-flex w-max items-center gap-1 rounded-full bg-[#f4e5ff] px-2 py-0.5 text-[11px] font-medium text-[#ad46ff] dark:bg-purple-800 dark:text-white">
            <app-icon-v2 name="zap" size="10" customClass="text-[#ad46ff] fill-current"></app-icon-v2>
            {{ getUrgentCount(row) }} Urgent Payment{{ getUrgentCount(row) === 1 ? '' : 's' }}
          </span>
          }
        </div>
        } @else {
        <span class="text-[12px] text-[#7d7d93] dark:text-ink-muted">—</span>
        }
      </ng-template>

      <ng-template #recurringAmountTemplate let-row>
        @if (showPayableAmountInRecurringColumn()) {
        <div class="flex flex-col gap-1">
          <span class="text-[14px] font-semibold text-[#141437] dark:text-white">{{ getPayableAmount(row) | currency }}</span>
          <ng-container *ngTemplateOutlet="urgentPaymentBadge; context: { $implicit: row }"></ng-container>
        </div>
        } @else {
        <span class="text-[14px] font-semibold text-[#141437] dark:text-white">{{ getDeductedAmount(row) | currency }}</span>
        }
      </ng-template>

      <ng-template #rewardTypeTemplate let-row>
        <span class="text-[14px] text-[#141437] dark:text-white">{{ getRewardTypeLabel(row) }}</span>
      </ng-template>

      <ng-template #achArPpTypeTemplate let-row>
        <span class="text-[14px] font-semibold" [ngClass]="getAchArPpTypeClass(row)">{{ getAchArPpTypeLabel(row) }}</span>
      </ng-template>

      <ng-template #transferToBusinessTemplate let-row>
        <div class="flex flex-col gap-1">
          <span class="text-[14px] font-semibold text-[#141437] dark:text-white">{{ getPayableAmount(row) | currency }}</span>
          <ng-container *ngTemplateOutlet="urgentPaymentBadge; context: { $implicit: row }"></ng-container>
        </div>
      </ng-template>

      <ng-template #lastContractDateTemplate let-row>
        <span class="text-[14px]">{{ getLastContractDate(row) }}</span>
      </ng-template>

      <ng-template #orpTemplate let-row>
        <span class="text-[14px] text-[#141437] dark:text-white">{{ getOrpLabel(row) }}</span>
      </ng-template>

      <ng-template #instantClaimTemplate let-row>
        <span class="text-[14px] text-[#141437] dark:text-white">{{ getInstantClaimLabel(row) }}</span>
      </ng-template>

      <ng-template #pfStatusTemplate let-row>
        <span class="text-[14px] font-medium" [ngClass]="{
          'text-[#15b268]': getStatusTone(getStatusLabel(row)) === 'success',
          'text-[#f05050]': getStatusTone(getStatusLabel(row)) === 'danger',
          'text-[#ffa514]': getStatusTone(getStatusLabel(row)) === 'warning',
          'text-[#7d7d93] dark:text-ink-muted': getStatusTone(getStatusLabel(row)) === 'neutral'
        }">
          {{ getStatusLabel(row) }}
        </span>
      </ng-template>

      <ng-template #statusTemplate let-row>
        <span class="text-[14px] font-medium" [ngClass]="{
          'text-[#15b268]': getStatusTone(getStatusLabel(row)) === 'success',
          'text-[#f05050]': getStatusTone(getStatusLabel(row)) === 'danger',
          'text-[#ffa514]': getStatusTone(getStatusLabel(row)) === 'warning',
          'text-[#7d7d93] dark:text-ink-muted': getStatusTone(getStatusLabel(row)) === 'neutral'
        }">
          {{ getStatusLabel(row) }}
        </span>
      </ng-template>

      <ng-template #urgentPaymentsTemplate let-row>
        <span class="text-[14px]"
          class="inline-flex rounded-[8px] bg-[#f4e5ff] px-2 py-1 text-[12px] font-medium text-[#ad46ff] dark:bg-purple-800 dark:text-white">
          {{ getUrgentCount(row) }} urgent
        </span>
      </ng-template>

      <ng-template #paymentDateTemplate let-row>
        <span class="text-[14px]">{{ getPaymentDate(row) }}</span>
      </ng-template>

      <ng-template #receivedOnTemplate let-row>
        <span class="text-[14px]">{{ getReceivedDate(row) }}</span>
      </ng-template>

      <ng-template #urgentPaymentBadge let-row>
        @if (isUrgent(row)) {
        <span
          class="inline-flex w-max items-center gap-1 rounded-full bg-[#f4e5ff] px-2 py-0.5 text-[11px] font-medium text-[#ad46ff] dark:bg-purple-800 dark:text-white">
          <app-icon-v2 name="zap" size="10" customClass="text-[#ad46ff] fill-current"></app-icon-v2>
          Urgent Payment
        </span>
        }
      </ng-template>

      <ng-template #amountToPayTemplate let-row>
        <div class="flex flex-col gap-1">
          <span class="font-semibold text-[#141437] dark:text-white">{{ getPayableAmount(row) | currency }}</span>
          <ng-container *ngTemplateOutlet="urgentPaymentBadge; context: { $implicit: row }"></ng-container>
        </div>
      </ng-template>

      <ng-template #businessAmountTemplate let-row>
        <div class="inline-flex items-center gap-1.5">
          <span class="text-[14px] font-semibold text-[#141437] dark:text-white">
            {{ getBusinessSummaryAmount(row) | currency }}
          </span>
          <!-- <app-icon-v2 name="info" size="14" customClass="text-[#7d7d93] dark:text-ink-muted"></app-icon-v2> -->
        </div>
      </ng-template>

      <ng-template #actionTemplate let-row>
        <div class="flex items-center justify-start gap-2" data-row-action-menu-root (click)="$event.stopPropagation()">
          <button type="button"
            class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="isRowActionsDisabled() || submitting() || !isRowPayable(row)" (click)="paySingle(row)">
            Pay
          </button>

          <div class="relative z-[1]">
            <button type="button"
              class="flex h-8 w-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white text-[#7d7d93] hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-60 dark:border-surface-3 dark:bg-surface-1 dark:text-ink-muted dark:hover:bg-surface-3"
              [disabled]="isRowActionsDisabled()"
              [attr.aria-expanded]="isActionMenuOpen(row)" aria-haspopup="true"
              (click)="toggleActionMenu(row, $event)">
              <app-icon-v2 name="ellipsis-vertical" size="16"></app-icon-v2>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template #businessActionTemplate let-row>
        <div class="flex items-center justify-start gap-2" data-row-action-menu-root (click)="$event.stopPropagation()">
          <button type="button"
            class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="isRowActionsDisabled()" (click)="openBusinessDetails(row)">
            View Payments
          </button>
          <button type="button"
            class="inline-flex h-8 items-center justify-center rounded-[8px] border border-[#AD46FF] bg-white px-4 text-[13px] font-medium text-[#AD46FF] transition hover:bg-[#f4e5ff] disabled:cursor-not-allowed disabled:opacity-60 dark:border-purple-500 dark:bg-surface-1 dark:hover:bg-white/5"
            [disabled]="isRowActionsDisabled() || submitting() || !canSelectRow(row)" (click)="payBusinessAll(row)">
            Pay All
          </button>
          <div class="relative z-[1] h-8 w-8 shrink-0">
            <button *ngIf="hasUrgentPaymentAvailable(row)" type="button"
              class="flex h-8 w-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white text-[#7d7d93] hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-60 dark:border-surface-3 dark:bg-surface-1 dark:text-ink-muted dark:hover:bg-surface-3"
              [disabled]="isRowActionsDisabled()"
              [attr.aria-expanded]="isActionMenuOpen(row)" aria-haspopup="true"
              (click)="toggleActionMenu(row, $event)">
              <app-icon-v2 name="ellipsis-vertical" size="16"></app-icon-v2>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template #contractActionTemplate let-row>
        <div class="flex items-center justify-start gap-2" data-row-action-menu-root (click)="$event.stopPropagation()">
          <button type="button"
            class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="isRowActionsDisabled() || submitting() || !isRowPayable(row)" (click)="paySingle(row)">
            Pay
          </button>
          <div class="relative z-[1]">
            <button type="button"
              class="flex h-8 w-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white text-[#7d7d93] hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-60 dark:border-surface-3 dark:bg-surface-1 dark:text-ink-muted dark:hover:bg-surface-3"
              [disabled]="isRowActionsDisabled()"
              [attr.aria-expanded]="isActionMenuOpen(row)" aria-haspopup="true"
              (click)="toggleActionMenu(row, $event)">
              <app-icon-v2 name="ellipsis-vertical" size="16"></app-icon-v2>
            </button>
          </div>
        </div>
      </ng-template>

      <!-- Lendee Cell Templates -->
      <ng-template #lendeeSerialNoTemplate let-row let-i="index">
        <span class="text-[14px] font-medium tabular-nums text-[#141437] dark:text-white">{{ offset() + i + 1 }}</span>
      </ng-template>

      <ng-template #lendeePayableAmountTemplate let-row>
        <span class="text-[14px] font-semibold tabular-nums text-[#141437] dark:text-white">
          {{ getLendeePayableAmount(row) | currency }}
        </span>
      </ng-template>

      <ng-template #lendeeShareTypeTemplate let-row>
        <span class="text-[14px] text-[#141437] dark:text-white">{{ getLendeeShareType(row) }}</span>
      </ng-template>

      <ng-template #lendeeStatusTemplate let-row>
        <span
          class="inline-flex rounded-full px-2.5 py-1 text-[12px] font-semibold"
          [ngClass]="{
            'bg-[#edfff3] text-[#15b268] dark:bg-[#173b31] dark:text-[#7ae5ac]': isLendeePaid(row),
            'bg-[#fff0f0] text-[#f05050] dark:bg-[#3f1d29] dark:text-[#ff9090]': !isLendeePaid(row) && getLendeeStatus(row) === 'Unpaid'
          }"
        >
          {{ getLendeeStatus(row) }}
        </span>
      </ng-template>

<ng-template #lendeeContractDetailsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <a class="font-semibold text-[#0c66e8] dark:text-[#6eb3ff]">{{ getLendeeContractCode(row) }}</a>
    <div class="text-[#7d7d93] dark:text-ink-muted">Contract Type: <span class="text-[#141437] dark:text-white">{{ getLendeeContractType(row) }}</span></div>
    <div class="grid transition-all duration-300 ease-in-out"
      [ngClass]="isLendeeRowExpanded(row) ? 'mt-1 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'">
      <div class="overflow-hidden space-y-1 border-t border-dashed border-[#e5e7eb] pt-1 dark:border-surface-3">
        <div class="text-[#7d7d93] dark:text-ink-muted">Contract State:
          <span class="inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ml-1"
            [ngClass]="{
              'bg-[#edfff3] text-[#15b268] dark:bg-[#173b31] dark:text-[#7ae5ac]': getLendeeContractState(row) === 'Active',
              'bg-[#e9f4ff] text-[#0c66e8] dark:bg-blue-500/15 dark:text-[#9cc5ff]': getLendeeContractState(row) === 'Completed',
              'bg-[#fff0f0] text-[#f05050] dark:bg-[#3f1d29] dark:text-[#ff9090]': getLendeeContractState(row) === 'Cancelled',
              'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400': getLendeeContractState(row) === 'Initiated' || getLendeeContractState(row) === '-'
            }"
          >{{ getLendeeContractState(row) }}</span>
        </div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Financed Amount: <span class="text-[#141437] dark:text-white">{{ getLendeeFinancedAmount(row) | currency }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Remaining Payments: <span class="text-[#141437] dark:text-white">{{ getLendeeRemainingPayments(row) }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lendeeBusinessDetailsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <a class="font-semibold text-[#0c66e8] dark:text-[#6eb3ff]">{{ getLendeePracticeName(row) }}</a>
    <div class="text-[#7d7d93] dark:text-ink-muted">Business Owner Name: <span class="text-[#141437] dark:text-white">{{ getLendeeBusinessOwnerName(row) }}</span></div>
    <div class="grid transition-all duration-300 ease-in-out"
      [ngClass]="isLendeeRowExpanded(row) ? 'mt-1 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'">
      <div class="overflow-hidden space-y-1 border-t border-dashed border-[#e5e7eb] pt-1 dark:border-surface-3">
        <div class="text-[#7d7d93] dark:text-ink-muted">Early Payout Amount: <span class="text-[#141437] dark:text-white">{{ getLendeeEarlyPayoutAmount(row) | currency }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Status:
          <span class="inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ml-1"
            [ngClass]="{
              'bg-[#edfff3] text-[#15b268] dark:bg-[#173b31] dark:text-[#7ae5ac]': getLendeeContractState(row) === 'Active',
              'bg-[#e9f4ff] text-[#0c66e8] dark:bg-blue-500/15 dark:text-[#9cc5ff]': getLendeeContractState(row) === 'Completed',
              'bg-[#fff0f0] text-[#f05050] dark:bg-[#3f1d29] dark:text-[#ff9090]': getLendeeContractState(row) === 'Cancelled',
              'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400': getLendeeContractState(row) === 'Initiated' || getLendeeContractState(row) === '-'
            }"
          >{{ getLendeeContractState(row) }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lendeePaymentDetailsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <div class="text-[#7d7d93] dark:text-ink-muted">Payment Type: <span class="text-[#141437] dark:text-white">{{ getLendeePaymentTypeName(row) }}</span></div>
    <div class="text-[#7d7d93] dark:text-ink-muted">Amount Deducted: <span class="text-[#141437] dark:text-white">{{ getLendeeAmountDeducted(row) | currency }}</span></div>
    <div class="grid transition-all duration-300 ease-in-out"
      [ngClass]="isLendeeRowExpanded(row) ? 'mt-1 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'">
      <div class="overflow-hidden space-y-1 border-t border-dashed border-[#e5e7eb] pt-1 dark:border-surface-3">
        <div class="text-[#7d7d93] dark:text-ink-muted">Transaction Fee: <span class="text-[#141437] dark:text-white">{{ getLendeeTransactionFee(row) | currency }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Paid to Business: <span class="text-[#141437] dark:text-white">{{ getLendeePaidToBusiness(row) }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Payment Date: <span class="text-[#141437] dark:text-white">{{ getLendeePaymentDate(row) }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

      <ng-template #lendeeActionTemplate let-row>
        <div class="flex items-center justify-start gap-2" data-row-action-menu-root (click)="$event.stopPropagation()">
          <button
            type="button"
            class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="submitting() || isLendeePaid(row)"
            (click)="payLendeeSingle(row)"
          >
            Pay
          </button>
          <button
            type="button"
            class="inline-flex h-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white px-3 text-[13px] font-medium text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:bg-surface-1 dark:text-ink-soft dark:hover:bg-surface-3"
            (click)="toggleLendeeDetails(row)"
          >
            @if (isLendeeRowExpanded(row)) {
              Hide Details
            } @else {
              Show Details
            }
          </button>
          <div class="relative z-[1]">
            <button
              type="button"
              class="flex h-8 w-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white text-[#7d7d93] hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-60 dark:border-surface-3 dark:bg-surface-1 dark:text-ink-muted dark:hover:bg-surface-3"
              [attr.aria-expanded]="isActionMenuOpen(row)"
              aria-haspopup="true"
              (click)="toggleActionMenu(row, $event)"
            >
              <app-icon-v2 name="ellipsis-vertical" size="16"></app-icon-v2>
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-template>
</section>

<ng-container *ngIf="openContractPopoverRow() && contractPopoverPosition() as contractPos">
  <div #contractPopoverPanel data-contract-popover-root
    class="fixed z-[200] w-[220px] rounded-[10px] border border-[#e5e7eb] bg-white p-3 shadow-xl dark:border-surface-3 dark:bg-surface-1"
    [style.top.px]="contractPos.top" [style.left.px]="contractPos.left"
    (mouseenter)="cancelCloseContractPopover()"
    (mouseleave)="closeContractPopover()">
    <p class="mb-2 text-[12px] text-[#7d7d93] dark:text-ink-muted">Contract Breakdown</p>
    <div class="space-y-1.5">
      <div *ngFor="let item of getRowContractBreakdownRows(openContractPopoverRow()!)"
        class="flex items-center justify-between gap-4 text-[13px]">
        <span class="inline-flex items-center gap-2 text-[#38385b] dark:text-ink-soft">
          <span class="h-2 w-2 shrink-0 rounded-full" [style.backgroundColor]="item.color"></span>
          {{ item.label }}
        </span>
        <span class="font-semibold text-[#141437] dark:text-white">{{ item.value }}</span>
      </div>
    </div>
    <div
      class="mt-2 flex items-center justify-between gap-4 border-t border-[#dfe5ed] pt-2 text-[12px] dark:border-surface-3">
      <span class="text-[#7d7d93] dark:text-ink-muted">Last Created On</span>
      <span class="font-semibold text-[#141437] dark:text-white">{{ formatContractLastDate(openContractPopoverRow()!) }}</span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="openActionMenuRow() && actionMenuPosition() as menuPos">
  <div class="fixed inset-0 z-[150]" (click)="closeActionMenu()" aria-hidden="true"></div>
  <div #actionMenuPanel data-row-action-menu-root
    class="fixed z-[200] overflow-hidden rounded-[10px] border border-[#e5e7eb] bg-white py-1 shadow-xl dark:border-surface-3 dark:bg-surface-1"
    [class.w-[220px]]="usesWideActionMenu()"
    [class.w-[160px]]="!usesWideActionMenu()"
    [style.top.px]="menuPos.top" [style.left.px]="menuPos.left"
    (click)="$event.stopPropagation()">
    <button *ngFor="let option of getDisplayRowMenuOptions(openActionMenuRow()!)" type="button"
      class="flex w-full items-center gap-2 px-3 py-2 text-left text-[13px] text-[#38385b] transition hover:bg-[#f2f5f8] dark:text-ink-soft dark:hover:bg-surface-3"
      (click)="onRowMenuOptionSelect(option.value, openActionMenuRow()!, $event)">
      <app-icon-v2 *ngIf="option.icon" [name]="option.icon" size="16"
        [customClass]="option.iconClass || 'text-[#7d7d93] dark:text-ink-muted'"></app-icon-v2>
      <span>{{ option.label }}</span>
    </button>
  </div>
</ng-container>

<div
  class="bulk-selection-footer fixed bottom-0 right-0 z-[100] border-t border-[#e5e7eb] bg-white p-4 shadow-[0_-4px_10px_0_rgba(0,0,0,0.05)] transition-[transform,opacity] duration-300 ease-out will-change-transform dark:border-surface-3 dark:bg-surface-1"
  [class.bulk-selection-footer--visible]="selectedIds().length > 0"
  [attr.aria-hidden]="selectedIds().length === 0"
  [style.left]="'var(--sidebar-width, 0px)'">
  <div class="mx-auto flex flex-col items-start gap-4 xl:flex-row xl:items-center xl:justify-between px-4 xl:px-8">
    <div class="flex flex-col">
      <div class="text-[24px] font-bold text-[#141437] dark:text-white leading-tight">
        {{ totalSelectedAmount() | currency }}
      </div>
      <div class="flex flex-wrap items-center gap-4 text-[13px] text-[#7d7d93] dark:text-ink-muted mt-1">
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="building" size="14" />
          Paying to <span class="font-semibold text-[#141437] dark:text-white">{{ selectedBusinessesCount() }}</span>
          businesses
        </div>
        <span class="text-[#e5e7eb] dark:text-surface-3">|</span>
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="receipt" size="14" />
          <span class="font-semibold text-[#141437] dark:text-white">{{ selectedPayableCount() }}</span> Payments
        </div>
        <div *ngIf="selectedUrgentCount() > 0"
          class="flex items-center gap-1.5 rounded-full bg-[#f4e5ff] px-2.5 py-0.5 text-[#ad46ff] dark:bg-purple-800/20">
          <app-icon-v2 name="zap" size="14" strokeWidth="2.5" />
          <span class="font-semibold">{{ selectedUrgentCount() }} urgent payments - {{ selectedUrgentAmount() | currency
            }}</span>
        </div>
      </div>
    </div>

    <div class="flex items-center gap-3">
      @if (moreOptions().length) {
      <app-dropdown
        [options]="moreOptions()"
        selectionMode="single"
        selectionStyle="none"
        [clearable]="false"
        [disabled]="submitting()"
        variant="outline"
        size="md"
        position="top-left"
        placeholder="More"
        [fullWidth]="false"
        customWidth="180px"
        menuTitle="More Options"
        menuClass="!z-[200] shadow-xl"
        (selectionChange)="onMoreOptionClick($event)"
      >
        <button
          appDropdownTrigger
          type="button"
          class="inline-flex h-11 items-center gap-2 rounded-[10px] border border-[#AD46FF] bg-white px-5 text-[14px] font-medium text-[#AD46FF] transition hover:border-[#962ef7] hover:bg-[#faf5ff] hover:text-[#962ef7] dark:border-purple-500 dark:bg-surface-1 dark:text-purple-400 dark:hover:border-line-strong dark:hover:bg-surface-3 dark:hover:text-white"
        >
          More
        </button>
      </app-dropdown>
      }

      <button type="button"
        class="inline-flex h-11 items-center rounded-[10px] bg-[#AD46FF] px-6 text-[14px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="submitting() || !selectedPayableCount()" (click)="paySelected()">
        {{ submitting() ? 'Processing...' : 'Make Payments' }}
      </button>
    </div>
  </div>
</div>
